/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Push: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M22.707 11.2928C23.0976 11.6834 23.0976 12.3164 22.707 12.7069L17.707 17.7069L16.293 16.2928L20.5859 11.9999L16.293 7.70691L17.707 6.29285L22.707 11.2928Z'
      fill='currentColor'
    />
  </React.Fragment>
)
